/** Defers tracking so click work stays off INP. */
export const deferTracking = (track: () => void) => setTimeout(track, 0);
